import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, Events } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { Storage } from '@ionic/storage';
import { DashboardPage } from '../dashboard/dashboard';
import { MobileAppService } from '../../services/mobile-app';
import { HomePage } from '../home/home';
import { UtilService } from '../../services/util';
import { environment } from '../../environments/environment';
import { ForgotPassPage } from '../forgot-pass/forgot-pass';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-otp-login',
  templateUrl: 'otp-login.html',
})
export class OtpLoginPage {

  loading = {
    send: false,
    resend: false
  };

  data: any = {};
  events: any = {};

  public username: string;
  public otp: number;
  public token: string;

  private isUsernameValid: boolean = true;
  private isPasswordValid: boolean = true;

  public message = {
    text : "",
    color : ""
  };
  otpRes: any = {};

  private otpSent = false;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private loginProvider: LoginProvider, 
    private storage: Storage, 
    private actionSheetCtrl: ActionSheetController,
    public event: Events,
    private mobileApp: MobileAppService,
    private util: UtilService) {
    this.data = {
      "background"      : "assets/images/background/26.jpg",
      "username"        : "Email or Phone no.",
      "password"        : "Enter your password",
      "labelUsername"   : "USERNAME",
      "labelPassword"   : "PASSWORD",
      "register"        : "Register now!",
      "forgotPassword"  : "Forgot password?",
      "login"           : "Send OTP",
      "loginFacebook"   : "Login With",
      "subtitle"        : "Welcome to Isociety",
      "title"           : "OTP Login",
      "otp"             : "OTP Login",
      "logo"            : "assets/images/logo/ism"+environment.icon+".png",
      "errorUser"       : "Field can't be empty",
      "errorPassword"   : "Field can't be empty"
    };

    this.events = {};
  }

  onEvent = (event: string): void => {
    //verify otp
    if(this.otpSent && this.data.login == "Verify OTP"){
      if (event == "onLogin" && !this.validate()) {
        return ;
      }else{
        this.loading.send = true;
        let params = {
          'id': this.otpRes.id,
          'otp': this.otp
        };
        console.log(params);
        this.loginProvider.verifyOtp(params).subscribe((res) => {
          this.loading.send = false;
          if(res.status == 'success'){
            this.message = {text: res.message, color: 'green'};
            this.token = res.data.token;
            this.loginProvider.loadAccount(res.data.token).subscribe((res) => {
              if(res.status == 'success'){
                this.showActionSheet(res.data);
              }else{
                this.message = {text: res.message, color: 'red'};
              }
            }, err => {
              this.util.showNoInternet();
            });
          }else if(!res.message){
            this.message = {text: 'Try again!', color: 'red'};
          }else{
            this.message = {text: res.message, color: 'red'};
          }
        }, err => {
          this.loading.send = false;
          this.util.showNoInternet();
        });
      }
    }
    //send otp
    else if(this.validate() && !this.otpSent) {
      this.loading.send = true;
      let params = {
        'identity' : this.username,
        'app_roles': environment.allowRole
      };
      this.loginProvider.sendOtp(params).subscribe((res) => {
        this.loading.send = false;
        if(res.status == 'success'){
          this.message = {text: res.message, color: 'green'};
          this.otpSent = true;
          this.data.login = "Verify OTP";
          this.otpRes = res.data;
        }else if(!this.message){
          this.message = {text: 'Try again!', color: 'red'};
        }else{
          this.message = {text: res.message, color: 'red'};
        }
      }, err => {
        this.util.showNoInternet();
      });
    }
  }

  showActionSheet(data: any){
    let buttons = [];
    data.forEach(element => {
      buttons.push({
        text: (element.display_unit_no ? element.display_unit_no+"-" :( element.flat_no? element.flat_no+"-" : "") ) + element.name 
        + (" ("+element.society_name+")"),
        handler: () => {
          this.otpLogin(element);
        }
      });
    });
    buttons.push({
      text: 'Cancel',
      role: 'cancel',
      handler: () => {
        this.navCtrl.setRoot(HomePage);
        this.navCtrl.push(ForgotPassPage);
      }
    })
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Select Your Account',
      buttons: buttons
    });
    actionSheet.present();
  }

  otpLogin(element: any){
    this.loginProvider.otpLogin(element, this.token).subscribe((res) => {
      if(res.status == 'success'){
        this.storage.set('loginDetails', res.data).then(val => {
          if(environment.switchToWeb) this.mobileApp.registerApp();
          this.event.publish('user:created', res.data);
          (environment.switchToWeb) ? this.mobileApp.switchToWeb() : this.navCtrl.setRoot(DashboardPage);
          this.navCtrl.push(ForgotPassPage);
        })
      }else{
        this.message = {text: res.message, color: 'red'};
      }
    }, err => {
      this.util.showNoInternet();
    });
  }

  onResendOtp():void {
    this.loading.resend = true;
    let params = {
      'id': this.otpRes.id
    }
    this.loginProvider.resendOtp(params).subscribe((res) => {
      this.loading.resend = false;
      this.message = {text: res.message, color: 'green'};      
    }, err => {
      this.util.showNoInternet();
    });
  }

  validate():boolean {
    this.isUsernameValid = true;
    this.isPasswordValid = true;

    if (!this.username ||this.username.length == 0) {
        this.isUsernameValid = false;
    }

    if ((!this.otp || this.otp.toString().length == 0) && this.otpSent) {
        this.isPasswordValid = false;
    }

    return this.isPasswordValid && this.isUsernameValid;
  }

}



// WEBPACK FOOTER //
// ./src/pages/otp-login/otp-login.ts